import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row, Badge } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import CampaignStatusModal from "./components/CampaignStatusModal";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  addCampaignStatus,
  deleteCampaignStatus,
  getCampaignStatusesList,
  updateCampaignStatusProfile,
} from "../../../store/campaigns/statuses/actions";
import styled from "styled-components";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class Statuses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddCampaignStatuses: false,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getCampaignStatuses(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleTableChange = data => {
    this.props.getCampaignStatuses(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddStatusesModal = () => {
    this.setState(prevState => ({
      viewAddCampaignStatuses: !prevState.viewAddCampaignStatuses,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteCampaignStatus(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_campaignstatusmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_campaignstatusmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const colorFormatter = (cell, row, label) => {
      return (
        <Badge
          style={{
            background: row[label] !== "#ffffff" ? row[label] : "#000000",
          }}
          className="font-size-12"
        >
          {row[label]}
        </Badge>
      );
    };

    const onClickRow = (e, row, type) => {
      if (this.props.permissions["view_campaignstatusmodel"]) {
        this.setState(prevState => ({
          viewAddCampaignStatuses: !prevState.viewAddCampaignStatuses,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "name"),
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "description"),
      },
      {
        dataField: "color",
        text: "Color",
        sort: true,
        formatter: (cell, row) => colorFormatter(cell, row, "color"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        {this.state.viewAddCampaignStatuses && (
          <CampaignStatusModal
            toggle={this.toggleViewAddStatusesModal}
            isOpen={this.state.viewAddCampaignStatuses}
            data={this.props.data}
            addCampaignStatus={this.props.addCampaignStatus}
            updateCampaignStatusProfile={this.props.updateCampaignStatusProfile}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        <div className="page-content">
        <ModifiedMetaTags title="Campaign statuses | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaign statuses"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this status? <br /> If you are not
                  sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions["add_campaignstatusmodel"] ===
                          "add_campaignstatusmodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddStatusesModal}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            status
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Statuses.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignStatuses: PropTypes.func,
  addCampaignStatus: PropTypes.func,
  deleteCampaignStatus: PropTypes.func,
  updateCampaignStatusProfile: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.CampaignStatuses.data,
  loading: state.CampaignStatuses.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignStatuses: getCampaignStatusesList,
  addCampaignStatus,
  deleteCampaignStatus,
  updateCampaignStatusProfile,
})(Statuses);
